if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (document.querySelector('.upsell-is-active')) {
        this.submitButton = document.querySelector('.upsell-is-active');
      }
      else {
        this.submitButton = this.querySelector('[type="submit"]');
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      delete config.headers['Accept'];

      const formData = new FormData(this.form);
      let formDataUpdate = {};

      if (this.classList.contains('product-form--multiple-items')) {
        let itemsArray = [];

        this.form.querySelectorAll('[name^="items"]').forEach(function (element) {
          let match = element.name.match(/\[(\d+)\]\[(\w+)\]/);
          let index = parseInt(match[1]);
          let property = match[2];

          if (!itemsArray[index]) {
            itemsArray[index] = {};
          }

          itemsArray[index][property] = element.value;
        });

        formDataUpdate = {
          items: itemsArray
        };
      } else {
        const object = {};
        formData.forEach(function (value, key) {
          if (key === 'quantity' || key === 'id') {
            object[key] = parseInt(value);
          } else {
            object[key] = value;
          }
        });
        formDataUpdate = {
          items: [object]
        };
  
        // Add product rebuy upsells to cart
        if (document.querySelectorAll('.product-rebuy').length > 0) {
          document.querySelectorAll('.product-rebuy').forEach((input) => {
            if (input.checked) {
              const itemObject = {
                quantity: 1,
                id: input.id
              };
              formDataUpdate.items.push(itemObject)
            }
          });
        };
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);

        formDataUpdate['sections'] = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        formDataUpdate['sections_url'] = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(formDataUpdate);

      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (document.querySelector('.product-rebuy-submit')) document.querySelector('.product-rebuy-submit').classList.remove('upsell-is-active')
          this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          // Refresh Rebuy product list
          rebuy_recommended();
          // Affirm cart drawer messaging
          affirm.ui.refresh();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


// UUID is needed for the recently viewed endpoind
function getRebuyUuid() {
  return new Promise((resolve, reject) => {
    const checkRebuyStatus = setInterval(() => {
      if (
        typeof Rebuy !== "undefined" &&
        Rebuy._status === "initialized" &&
        typeof Rebuy.identity === "function"
      ) {
        clearInterval(checkRebuyStatus);
        resolve(Rebuy.identity().uuid);
      }
    }, 100); 
  });
}

// Custom Element for the Rebuy Widget
class rebuyWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector(".product-rebuy-content");
    this.template = this.querySelector("template");
    this.submitButton = this.querySelector(".product-rebuy-submit");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    };
  
    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
  
  // Fetch the products from the Rebuy Engine
  renderProducts() {
    getRebuyUuid().then((uuid) => {
      const requestParameters = new URLSearchParams({
        limit: this.dataset.limit,
        key: "01e06cc55a2467473990fa0d87b880c0bf66c72b",
        shopify_product_ids: this.dataset.ids,
        uuid: uuid,
      });

      fetch(`${this.dataset.url}${requestParameters.toString()}`)
        .then((response) => response.json())
        .then((data) => {
          const templateHtml = this.template.innerHTML;
          const result = Mustache.render(templateHtml, data.data);
          this.targetElement.innerHTML += result;

          // Check if the widget has the 'product-rebuy-recommendations' class
          if (this.querySelector(".is-slider")) {
            // Add slider controls
            let sliderControlsHtml = `
            <div class="slider-dots no-js-hidden color-background-1 large-up-hide">
              <div class="slider-counter slider-counter--dots">
                <div class="slider__control-wrapper">`;
            for (let i = 0; i < data.data.length; i++) {
              sliderControlsHtml += `
              <button
                class="slider-counter__link slider-counter__link--dots link"
                aria-label="Load slide ${i + 1}"
                aria-controls="Slider-{{ section.id }}"
              >
                <span class="dot"></span>
              </button>`;
            }
            sliderControlsHtml += `
                </div>
              </div>
            </div>`;
            // Select the slider-component element and insert the slider controls inside it
            const sliderComponent = this.querySelector("slider-component");
            sliderComponent.insertAdjacentHTML("beforeend", sliderControlsHtml);
            sliderComponent.resetPages();
          }

          if (data.data.length === 0) {
            this.style.display = "none";
          } else {
            this.style.visibility = "visible";
            this.closest(".rebuy-container").style.visibility = "visible";
            this.closest(".rebuy-container").classList.add("rebuy-widget-loaded");
          }
          this.eventHandlers();
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
  eventHandlers() {
    this.inputs = this.querySelectorAll(".product-rebuy");
    if (this.inputs.length === 0) return;
    this.inputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.priceAndItemsSubmitUpdate(this.inputs);
      });
    });

    this.submitButton.addEventListener("click", (event) => {
      this.submitButton.classList.add("upsell-is-active");
      document.querySelector(".product-form__submit").click();
    });
  }
  priceAndItemsSubmitUpdate(inputs) {
    let items = [
      {
        id: this.dataset.product,
        quantity: 1,
      },
    ];
    let totalPrice = parseInt(
      this.querySelector("#product-rebuy-total").dataset.price
    );
    inputs.forEach((input) => {
      input.checked == true &&
        (totalPrice += parseFloat(input.dataset.price) * 100);
      if (input.checked) {
        let item = {
          id: input.id,
          quantity: 1,
        };
        items.push(item);
      }
    });

    // Update the total price in the widget footer
    this.querySelector("#product-rebuy-total").textContent =
      Shopify.formatMoney(totalPrice);
  }
}

customElements.define("rebuy-widget", rebuyWidget);


// Convermax
class convermaxWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector('.product-convermax-content');
    this.template = this.querySelector('template');
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
  renderProducts(show_only_model = false, count = 0) {
    const query = this.buildQuery(show_only_model);
    fetch(`https://pertronix.myconvermax.com/search.json?${query}`)
      .then(response => response.json())
      .then(data => {
        console.log('convermax', query, data)
        const products = data.Items;
        if (data.Messages.length == 0 || count > 1) {
          const products_to_render = [];
          products.forEach((product) => {
            if (product.id !== this.dataset.id && products_to_render.length < 4) {
              products_to_render.push(product);
            }
          });
          if (products_to_render.length > 0) {
            this.closest('.recommendations-section-container').style.visibility = 'visible';
            const templateHtml = this.template.innerHTML;
            const result = Mustache.render(templateHtml, products_to_render);
            this.targetElement.innerHTML += result;
          } else {
            this.renderProducts(true, count + 1);
          }
        } else {
          this.renderProducts(true, count + 1);
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
  buildQuery(show_only_model = false) {
    let query = '';
    if (!show_only_model) {
      query = new URLSearchParams({
        query: this.dataset.product.trim(),
        pagesize: this.dataset.limit + 1
      }).toString();
    } else {
      query = new URLSearchParams({
        pagesize: this.dataset.limit + 1
      }).toString();

    }
    if (localStorage.getItem('cm_variant-model') != null && this.dataset.product.trim().toLowerCase() != 'apparel') {
      let str = '';
      const arr = JSON.parse(localStorage.getItem('cm_variant-model'));
      for (let i = 0; i < arr.length; i++) {
        str += `facet.${i}.field=${arr[i].field}&facet.${i}.selection=${arr[i].term}`;
        if (i < arr.length - 1) {
          str += '&';
        }
      }
      query += '&' + str;
    }
    return query;
  }
}

customElements.define('convermax-widget', convermaxWidget);

(function () {
  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  waitForElm('.cm_verify-fitment__unknown .cm_verify-fitment_notes').then((elm) => {
    document.querySelector('.cm_verify-fitment_title').innerHTML = no_fitment_title;
    elm.innerHTML = no_fitment_text;
  });
})();

// yotpo reviews
function open_reviews() {
  let reviews_container = '';
  document.querySelectorAll('.accordion__title').forEach((accordion_title, index) => {
    if (accordion_title.innerText.toLowerCase().includes('reviews')) {
      const computedStyle = window.getComputedStyle(accordion_title);
      if (computedStyle.display !== 'none') {
        reviews_container = accordion_title.closest('details');
        reviews_container.setAttribute('open', true);
        reviews_container.open = true;
        reviews_container.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

}
document.querySelectorAll('.open-reviews').forEach((open_reviews_button) => {
  open_reviews_button.addEventListener('click', (e) => { open_reviews(); })
  open_reviews_button.addEventListener('keyup', (e) => { })
})

class BundleItemPump extends HTMLElement {
  constructor() {
    super();

    this.bundleItemQuantity = this.querySelector('.bundle-item--quantity').innerHTML;
  }

  updateContent(url, pumpId) {
    fetch(`${url}.json`).then(resp => resp.json()).then(resp => {
      for (const variant of resp.product.variants) {
        if (variant.id == parseInt(pumpId)) {
          this.innerHTML = this.setTemplate(resp.product, variant);
          
          let bundleTotal = document.querySelector('bundle-total');
    
          if (bundleTotal) {
            bundleTotal.updateTotal();
          }

          break;
        }
      }
    });
  }

  setTemplate(product, variant) {
    return `
      <a href="/products/${product.handle}?variant=${variant.id}" class="bundle-item link-unstyled">
        <div class="bundle-item--image">
          <img src="${product.image.src}&width=50&height=50" width="50" height="50" loading="lazy" />
          <span class="bundle-item--quantity">${this.bundleItemQuantity}</span>
        </div>
        <div class="bundle-item--content">
          <p class="text-body-small bundle-item--title">${product.title}</p>
          <p class="text-body-small bundle-item--sku">${variant.sku}</p>
        </div>
        <div class="bundle-item--price">
          <div class="price price--small">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">
                  $${(variant.price * parseFloat(this.bundleItemQuantity.replace('x', ''))).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </a>

      <input
        type="hidden"
        name="items[0][id]"
        value="${variant.id}"
        disabled
      >
      <input
        type="hidden"
        name="items[0][quantity]"
        value="${this.bundleItemQuantity.replace('x', '')}"
        disabled
      >   
    `;
  }
}

customElements.define('bundle-item-pump', BundleItemPump);

class BundlePumpSelector extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');

    if (this.select) {
      this.select.addEventListener('change', e => {
        let bundleItemPump = document.querySelector('bundle-item-pump');

        if (bundleItemPump) {
          bundleItemPump.updateContent(e.target.value, e.target.selectedOptions[0].dataset.pumpId);
        }
      });
    }
  }
}

customElements.define('bundle-pump-selector', BundlePumpSelector);

class BundleTotal extends HTMLElement {
  constructor() {
    super();

    this.totalContainer = this.querySelector('[data-total]');

    this.updateTotal();
  }

  updateTotal() {
    if (this.totalContainer) {
      let prices = document.querySelectorAll('.bundle-item--price .price__regular .price-item');
      let totalPrice = 0;

      if (prices) {
        for (const price of prices) {
          totalPrice += parseFloat(price.innerHTML.replace('$', '').replaceAll(' ', '').replaceAll('\n', '').replace(',', ''));;
          
          this.setPrice(totalPrice.toFixed(2));
        }
      }
    }
  }

  setPrice(price) {
    this.totalContainer.innerHTML = `$${price}`;
  }
}

customElements.define('bundle-total', BundleTotal);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.viewAll = this.querySelector('.bundle-products--view-all');

    if (this.viewAll) {
      this.viewAll.addEventListener('click', e => {
        this.classList.toggle('show');
      });
    }
  }
}

customElements.define('bundle-products', BundleProducts);